"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UITextToolbarSelect = _interopRequireDefault(require("UIComponents/editor/UITextToolbarSelect"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _StyleProtectedSelectItem = _interopRequireDefault(require("../style-protected/StyleProtectedSelectItem"));

var _withDisabledContext = _interopRequireDefault(require("../hoc/withDisabledContext"));

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.formatting.FontSelect." + suffix;
};

var FontSelect =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FontSelect, _Component);

  function FontSelect() {
    (0, _classCallCheck2.default)(this, FontSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FontSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(FontSelect, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          webfonts = _this$props.webfonts,
          fonts = _this$props.fonts,
          value = _this$props.value,
          onChange = _this$props.onChange,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["webfonts", "fonts", "value", "onChange"]);
      return _react.default.createElement(_UITextToolbarSelect.default, (0, _extends2.default)({}, rest, {
        searchable: false,
        options: webfonts && webfonts.length ? [].concat((0, _toConsumableArray2.default)(fonts), [{
          text: _react.default.createElement(_UIHelpIcon.default, {
            title: _I18n.default.text(i18nKey('webfontTooltip')),
            tooltipProps: {
              placement: 'bottom'
            }
          }, _I18n.default.text(i18nKey('webfontTitle'))),
          options: webfonts
        }]) : fonts,
        onChange: onChange,
        placeholder: _I18n.default.text(i18nKey('placeholder')),
        value: value,
        optionRenderer: function optionRenderer(option) {
          return _react.default.createElement(_StyleProtectedSelectItem.default, {
            className: "private-typeahead-result-label",
            title: option.text
          }, _react.default.createElement("span", {
            style: {
              fontFamily: option.value
            }
          }, option.text));
        }
      }));
    }
  }]);
  return FontSelect;
}(_react.Component);

FontSelect.propTypes = {
  onChange: _react.PropTypes.func.isRequired,
  value: _react.PropTypes.string,
  fonts: _react.PropTypes.array.isRequired,
  webfonts: _react.PropTypes.array
};

var _default = (0, _withDisabledContext.default)(FontSelect);

exports.default = _default;
module.exports = exports.default;